import { HelperCore, HelpOther } from '@/common/helper';
import { makeAutoObservable, runInAction } from 'mobx';
import request from '@src/common/request';
import chatStoreManager from '@/store/chat/manager';
import checkStore from '@/store/checkStore';
import EE from '@/common/event';
import client from '@/store/client';
import userStore from '@/store/user';

export const SHARE_STATUS_MAP = {
  NOT_SHARE: 0, // 未分享
  SHARE_CHECKING: 1, // 分享审核中
  SHARE_OPEN: 2, // 分享开放中
  SHARE_DISABLE: 3, // 分享禁用
  SHARE_AUDIT_FAIL: 4, // 审核不通过
};

export const SHARE_INFO_MAP = {
  [SHARE_STATUS_MAP.NOT_SHARE]: {
    text: '发布到广场',
    clickAction: 1,
    icon: 'chat_share_square',
    icon2: "https://p2.ssl.qhimg.com/t110b9a9301c5f7d6b054440627.png",
    successToast: '发布后，此案例将对所有人展示',
    textClass: "text-black",
    bgColor: ""
  },
  [SHARE_STATUS_MAP.SHARE_CHECKING]: {
    text: '发布审核中',
    ext: "（审核中）",
    clickAction: 0,
    icon: 'chat_share_checking',
    icon2: "https://p4.ssl.qhimg.com/t110b9a9301cded268cdcb5346d.png",
    successToast: '此案例通过审核后将对所有人可见，点击可取消发布',
    textClass: "text-[rgba(0,0,0,0.5)]",
    bgColor: ""
  },
  [SHARE_STATUS_MAP.SHARE_OPEN]: {
    text: '已发布广场',
    icon: 'chat_share_succ',
    icon2: "https://p0.ssl.qhimg.com/t110b9a930116c920fccafb0cfe.png",
    clickAction: 3,
    successToast: '此案例已对所有人可见，点击可取消发布',
    textClass: "text-[#FF3B30]",
    bgColor: "hover:bg-[#FEF5F6]"
  },
  [SHARE_STATUS_MAP.SHARE_DISABLE]: {
    text: '发布到广场',
    clickAction: 1,
    icon: 'chat_share_square',
    icon2: "https://p2.ssl.qhimg.com/t110b9a9301c5f7d6b054440627.png",
    successToast: '发布后，此案例将对所有人展示',
    textClass: "text-black",
    bgColor: ""
  },
  [SHARE_STATUS_MAP.SHARE_AUDIT_FAIL]: {
    text: '审核未通过',
    clickAction: 1,
    icon: 'chat_share_fail',
    icon2: "https://p2.ssl.qhimg.com/t110b9a9301c5f7d6b054440627.png",
    successToast: '审核不予通过，原因：',
    textClass: "text-black",
    bgColor: ""
  },
};


class Store {
  constructor() {
    makeAutoObservable(this);
  }

  /** 分享到案例广场的状态: 0未提交 1审核中 2开放中 3禁用 */
  shareStatus = 0;
  statusMsg = '';

  /** 复制链接 */
  copyLink = () => {
    // mcp智能体对话,走智能体分享
    const isMcpServer = chatStoreManager.current.lastMessage?.cloud_mcp?.length > 0 || chatStoreManager.current.lastMessage?.mcp?.length > 0;
    const { isMcpAgent, isAgentFlow } = chatStoreManager.current.mcpStore;
    if (isMcpAgent || isAgentFlow || isMcpServer) {
      this.copyAgentConversation();
    } else {
      this.copyNormalConversation();
    }
  };

  /** 复制智能体对话 */
  copyAgentConversation = () => {
    // chatStoreManager.current.mcpStore.copyShareUrl();
  };

  /** 复制普通大模型对话 */
  copyNormalConversation = data => {
    checkStore.reset();
    checkStore.setData({
      isShowCheck: true,
    });
    if (
      checkStore.data.checkList.length !=
      chatStoreManager.current.messageList.length
    ) {
      chatStoreManager.current.messageList.forEach(item => {
        checkStore.setChecked(item.msg_id + '-p', false);
        checkStore.setChecked(item.msg_id + '-r', false);
      });
    }
    checkStore.setAllChecked(true);
    checkStore.setData({
      allChecked: true,
    });
    EE.emit('chat:top');
  };

  getShareId = async () => {
    const res = await request.post('/share/gen', {
      cid: chatStoreManager.current.chatId,
      type: 2,
    });
    return res.data.id;
  };

  /** 分享智能体会话到案例广场 */
  shareToSquare = async (status = 1) => {
    // 审核中 不能操作
    // if(this.shareStatus === SHARE_STATUS_MAP.SHARE_CHECKING) return;

    const shareId = await this.getShareId();
    if (!shareId) {
      HelpOther.toast('分享失败, 请重试', 'error');
      return;
    }

    const { successToast, clickAction } = SHARE_INFO_MAP[this.shareStatus] || {};

    request
      .post('/ai_agent/example/share', {
        share_id: shareId,
        status: clickAction,
      })
      .then(res => {
        // HelpOther.toast(successToast, 'success');
        this.getShareStatus();
      })
      .catch(e => {
        HelpOther.toast(e.msg, 'error');
      });
  };

  /**
   * 获取当前分享到案例广场的状态
   * @returns {Promise<number>} 0未提交 1审核中 2开放中 3禁用
   *  */
  getShareStatus = async () => {
    if(!userStore.isUser){
      return 0;
    }

    const shareId = await this.getShareId();
    if (!shareId) return;
    const res = await request({
      url: '/ai_agent/example/status',
      method: 'get',
      params: {
        share_id: shareId,
      },
    });
    runInAction(() => {
      this.shareStatus = res.data.status;
      this.statusMsg = res.data.audit_fail_msg || '';
    });
    return res.data.status;
  };
}

const store = new Store();
export default store;
